import { StoreExaminationsById } from './models/store-examinations-by-id.js';

export type ExaminationState = {
  [clientCode: string]: {
    [patientId: number]: {
      examinations: StoreExaminationsById;
      departments: {
        [departmentId: number]: number[];
      };
    };
  };
};

export const initialExaminationState: ExaminationState = {};
